import { useEffect,useMemo } from 'react';

import { userStore } from '@stores/userStore';
import type { PermissionStoreInterface } from '@components/dictionary/FormWithActions/FormWithActions';
import type { ResourceNameKeys, ScopePermissions} from '@stores/userStore';

export const usePermission = (resourceName: ResourceNameKeys, store?: PermissionStoreInterface): ScopePermissions => {
  const { permissions } = userStore;
  const permission = useMemo(() => {
    const perm = permissions?.[resourceName]?.scopePermissions;
    if (perm) return perm;
    return { CREATE: false, DELETE: false, READ: false, UPDATE: false, VIEW: false };
  }, [permissions, resourceName]);

  useEffect(() => {
    store?.setHiddenEdit?.(!permission.UPDATE);
    store?.setHiddenDelete?.(!permission.DELETE);
    store?.setHiddenClean?.(store.isNew ? !permission.CREATE : !permission.UPDATE);
    store?.setHiddenSave?.(store.isNew ? !permission.CREATE : !permission.UPDATE);
  }, [permission.CREATE, permission.DELETE, permission.UPDATE, store, store?.isNew]);

  return permission;
};
